var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.94895C13.669 7.10931 13.3135 7.21766 12.9397 7.26663C13.3254 7.0143 13.6139 6.61716 13.7515 6.14932C13.3891 6.38465 12.9926 6.5503 12.579 6.63906C12.3009 6.31438 11.9326 6.09918 11.5311 6.02687C11.1297 5.95455 10.7177 6.02917 10.359 6.23914C10.0004 6.44911 9.71514 6.78268 9.54763 7.18806C9.38011 7.59344 9.33968 8.04795 9.43262 8.48103C8.69841 8.44072 7.98017 8.23206 7.32449 7.86859C6.66881 7.50512 6.09035 6.99496 5.62666 6.37122C5.46811 6.67027 5.37695 7.01699 5.37695 7.38625C5.37677 7.71867 5.45164 8.046 5.5949 8.33919C5.73817 8.63238 5.94541 8.88238 6.19823 9.06699C5.90502 9.05679 5.61829 8.97016 5.36189 8.81432V8.84032C5.36186 9.30655 5.50935 9.75843 5.77934 10.1193C6.04933 10.4802 6.42518 10.7278 6.84313 10.8201C6.57113 10.9006 6.28596 10.9125 6.00916 10.8548C6.12708 11.2559 6.35678 11.6068 6.66609 11.8581C6.97541 12.1094 7.34886 12.2487 7.73417 12.2564C7.08009 12.8178 6.27231 13.1224 5.44076 13.1211C5.29347 13.1211 5.14629 13.1117 5 13.0929C5.84406 13.6863 6.82661 14.0012 7.83009 14C11.227 14 13.084 10.9237 13.084 8.25566C13.084 8.16898 13.082 8.08143 13.0784 7.99475C13.4396 7.70913 13.7514 7.35543 13.9992 6.95025L14 6.94895Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/TwitterIcon.1a4ba29b68f5692144c991ab0b9fdc11.svg";
export { ForwardRef as ReactComponent };